import { getPath } from '@/router/common'

const baseUrl = {
  title: '仓储导入模板管理',
  path: 'WarehouseManagement'
}

export default [
  {
    path: getPath('WarehouseTemplate', baseUrl),
    name: 'WarehouseTemplate',
    component: () => import(/* webpackChunkName: "WarehouseTemplate" */ '@/views/warehouseManagement/warehouseTemplate/index.vue'),
    meta: {
      title: '仓储导入模板管理'
    }
  },
  {
    path: getPath('WarehouseTemplateEdit', baseUrl),
    name: 'WarehouseTemplateEdit',
    component: () => import(/* webpackChunkName: "WarehouseTemplateEdit" */ '@/views/warehouseManagement/warehouseTemplateEdit/index.vue'),
    meta: {
      title: '仓储导入模板管理新增编辑'
    }
  },
  {
    path: getPath('supplier', baseUrl),
    name: 'supplier',
    component: () => import(/* webpackChunkName: "supplier" */ '@/views/warehouseManagement/supplier/index.vue'),
    meta: {
      title: '供应商'
    }
  },
  {
    path: getPath('addOrEditSupplier', baseUrl),
    name: 'addOrEditSupplier',
    component: () => import(/* webpackChunkName: "addOrEditSupplier" */ '@/views/warehouseManagement/addOrEditSupplier/index.vue'),
    meta: {
      title: '新增修改供应商'
    }
  },
  {
    path: getPath('materialCode', baseUrl),
    name: 'materialCode',
    component: () => import(/* webpackChunkName: "materialCode" */ '@/views/warehouseManagement/materialCode/index.vue'),
    meta: {
      title: '物料编码'
    }
  },
  {
    path: getPath('addOrEditMaterialCode', baseUrl),
    name: 'addOrEditMaterialCode',
    component: () => import(/* webpackChunkName: "addOrEditMaterialCode" */ '@/views/warehouseManagement/addOrEditMaterialCode/index.vue'),
    meta: {
      title: '新增修改物料编码'
    }
  },
  {
    path: getPath('ImportRecordMaterial', baseUrl),
    name: 'ImportRecordMaterial',
    component: () => import(/* webpackChunkName: "ImportRecordMaterial" */ '@/views/warehouseManagement/importRecordMaterial/index.vue'),
    meta: {
      title: '物料编码导入记录'
    }
  },
  {
    path: getPath('warehousingData', baseUrl),
    name: 'warehousingData',
    component: () => import(/* webpackChunkName: "warehousingData" */ '@/views/warehouseManagement/warehousingData/index.vue'),
    meta: {
      title: '仓储资料'
    }
  },
  {
    path: getPath('addOrEditWarehousingData', baseUrl),
    name: 'addOrEditWarehousingData',
    component: () => import(/* webpackChunkName: "addOrEditWarehousingData" */ '@/views/warehouseManagement/addOrEditWarehousingData/index.vue'),
    meta: {
      title: '新增修改仓储资料'
    }
  },
  {
    path: getPath('warehousingCommonSettings', baseUrl),
    name: 'warehousingCommonSettings',
    component: () => import(/* webpackChunkName: "warehousingCommonSettings" */ '@/views/warehouseManagement/warehousingCommonSettings/index.vue'),
    meta: {
      title: '仓储常用设置'
    }
  },
  {
    path: getPath('intoWarehouseManagement', baseUrl),
    name: 'intoWarehouseManagement',
    component: () => import(/* webpackChunkName: "intoWarehouseManagement" */ '@/views/warehouseManagement/intoWarehouseManagement/index.vue'),
    meta: {
      title: '进仓管理'
    }
  },
  {
    path: getPath('addOrEditIntoWarehouse', baseUrl),
    name: 'addOrEditIntoWarehouse',
    component: () => import(/* webpackChunkName: "addOrEditIntoWarehouse" */ '@/views/warehouseManagement/addOrEditIntoWarehouse/index.vue'),
    meta: {
      title: '新增修改查看入库单/出库单/库存盘点单'
    }
  },
  {
    path: getPath('ImportRecord', baseUrl),
    name: 'ImportRecord',
    component: () => import(/* webpackChunkName: "ImportRecord" */ '@/views/warehouseManagement/importRecord/index.vue'),
    meta: {
      title: '仓储导入记录'
    }
  },
  {
    path: getPath('outofWarehouseManagement', baseUrl),
    name: 'outofWarehouseManagement',
    component: () => import(/* webpackChunkName: "outofWarehouseManagement" */ '@/views/warehouseManagement/outofWarehouseManagement/index.vue'),
    meta: {
      title: '出仓管理'
    }
  },
  {
    path: getPath('ImportDelivery', baseUrl),
    name: 'ImportDelivery',
    component: () => import(/* webpackChunkName: "ImportDelivery" */ '@/views/warehouseManagement/importDelivery/index.vue'),
    meta: {
      title: '仓储-出仓导入'
    }
  },
  {
    path: getPath('BatchPreview', baseUrl),
    name: 'BatchPreview',
    component: () => import(/* webpackChunkName: "BatchPreview" */ '@/views/warehouseManagement/batchPreview/index.vue'),
    meta: {
      title: '批量生成托运单预览'
    }
  },
  {
    path: getPath('outdetail', baseUrl),
    name: 'outdetail',
    component: () => import(/* webpackChunkName: "outdetail" */ '@/views/warehouseManagement/outdetail/index.vue'),
    meta: {
      title: '出仓明细列表'
    }
  },
  {
    path: getPath('inAndOutLaundryList', baseUrl),
    name: 'inAndOutLaundryList',
    component: () => import(/* webpackChunkName: "inAndOutLaundryList" */ '@/views/warehouseManagement/inAndOutLaundryList/index.vue'),
    meta: {
      title: '出入流水账'
    }
  },
  {
    path: getPath('intoWarehouseManagementorder', baseUrl),
    name: 'intoWarehouseManagementorder',
    component: () => import(/* webpackChunkName: "intoWarehouseManagementorder" */ '@/views/warehouseManagement/intoWarehouseManagementorder/index.vue'),
    meta: {
      title: '入库订单管理'
    }
  },
  {
    path: getPath('addOrEditIntoWarehouseorder', baseUrl),
    name: 'addOrEditIntoWarehouseorder',
    component: () => import(/* webpackChunkName: "addOrEditIntoWarehouseorder" */ '@/views/warehouseManagement/addOrEditIntoWarehouseorder/index.vue'),
    meta: {
      title: '入库或出库单详情'
    }
  },
  {
    path: getPath('ImportRecordorder', baseUrl),
    name: 'ImportRecordorder',
    component: () => import(/* webpackChunkName: "ImportRecordorder" */ '@/views/warehouseManagement/importRecordorder/index.vue'),
    meta: {
      title: '仓储-进仓导入(订单)'
    }
  },
  {
    path: getPath('outofWarehouseManagementorder', baseUrl),
    name: 'outofWarehouseManagementorder',
    component: () => import(/* webpackChunkName: "outofWarehouseManagementorder" */ '@/views/warehouseManagement/outofWarehouseManagementorder/index.vue'),
    meta: {
      title: '出库订单管理'
    }
  },
  {
    path: getPath('ImportDeliveryorder', baseUrl),
    name: 'ImportDeliveryorder',
    component: () => import(/* webpackChunkName: "ImportDeliveryorder" */ '@/views/warehouseManagement/importDeliveryorder/index.vue'),
    meta: {
      title: '仓储-出仓导入(订单)'
    }
  },
  {
    path: getPath('stockTaking', baseUrl),
    name: 'stockTaking',
    component: () => import(/* webpackChunkName: "stockTaking" */ '@/views/warehouseManagement/stockTaking/index.vue'),
    meta: {
      title: '库存盘点'
    }
  },
  {
    path: getPath('stockTakingDetail', baseUrl),
    name: 'stockTakingDetail',
    component: () => import(/* webpackChunkName: "stockTakingDetail" */ '@/views/warehouseManagement/stockTakingDetail/index.vue'),
    meta: {
      title: '库存盘点明细'
    }
  },
  {
    path: getPath('inventoryAdjustment', baseUrl),
    name: 'inventoryAdjustment',
    component: () => import(/* webpackChunkName: "inventoryAdjustment" */ '@/views/warehouseManagement/inventoryAdjustment/index.vue'),
    meta: {
      title: '库存调整'
    }
  },
  {
    path: getPath('modifyRecord', baseUrl),
    name: 'modifyRecord',
    component: () => import(/* webpackChunkName: "modifyRecord" */ '@/views/warehouseManagement/modifyRecord/index.vue'),
    meta: {
      title: '仓储修改记录'
    }
  },
  {
    path: getPath('judgestockTaking', baseUrl),
    name: 'judgestockTaking',
    component: () => import(/* webpackChunkName: "judgestockTaking" */ '@/views/warehouseManagement/judgestockTaking/index.vue'),
    meta: {
      title: '移库调整'
    }
  },
  {
    path: getPath('judgeEditWarehousingData', baseUrl),
    name: 'judgeEditWarehousingData',
    component: () => import(/* webpackChunkName: "judgeEditWarehousingData" */ '@/views/warehouseManagement/judgeEditWarehousingData/index.vue'),
    meta: {
      title: '移库调整单'
    }
  },
  {
    path: getPath('judgestockTakingjournal', baseUrl),
    name: 'judgestockTakingjournal',
    component: () => import(/* webpackChunkName: "judgestockTakingjournal" */ '@/views/warehouseManagement/judgestockTakingjournal/index.vue'),
    meta: {
      title: '移库调整日志记录'
    }
  },
  {
    path: getPath('indetail', baseUrl),
    name: 'warehouseManagement_indetail',
    component: () => import(/* webpackChunkName: "warehouseManagement_indetail" */ '@/views/warehouseManagement/indetail/index.vue'),
    meta: {
      title: '进仓明细'
    }
  }
]
